import { render, staticRenderFns } from "./CardLocationBase.vue?vue&type=template&id=008b807d&"
import script from "./CardLocationBase.vue?vue&type=script&lang=js&"
export * from "./CardLocationBase.vue?vue&type=script&lang=js&"
import style0 from "./CardLocationBase.vue?vue&type=style&index=0&id=008b807d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports